import { createSelector } from 'reselect';

const selectSystem = state => state.system;

const selectWarehouseAllocations = createSelector(
  selectSystem,
  ({ warehouseAllocations }) => warehouseAllocations,
);

export const selectSelectedAllocation = createSelector(
  selectWarehouseAllocations,
  ({ selectedAllocation }) => selectedAllocation,
);

export const selectCurtailments = createSelector(
  selectWarehouseAllocations,
  ({ curtailments }) => curtailments,
);

export const selectCurtailmentRules = createSelector(
  selectWarehouseAllocations,
  ({ curtailmentRules }) => curtailmentRules,
);
